import { lazy } from "react";

export default [
  {
    exact: true,
    path: "/:customerName/fire-department/request/detail/:requestId",
    component: lazy(
      () => import("src/views/arkadu/fireDepartment/FireRequestDetail"),
    ),
  },
  {
    exact: true,
    path: [
      "/:customerName/fire-department/:tabName",
      "/:customerName/fire-department/",
    ],
    component: lazy(
      () => import("src/views/arkadu/fireDepartment/FireDepartmentIndex"),
    ),
  },
];
